<template>
  <a-spin :spinning="isLoading">
    <div class="content-item text-center">
      <a-row :gutter="16" class="mt-3 mb-3">
        <div class="challenge-logo" v-if="isChallenge">
          <img src="resources/images/challenge-resource/js_challenge_logo.png" alt="Truelife" style="width: 200px; margin-top: 30px; margin-bottom: 30px" />
          <div class="description" style="display: flex; justify-content: center">
            <div style="max-width: 720px; text-align: left">
              <p style="font-size: 22px; padding-left: 15px; padding-right: 15px">
                Read the script while you record. &nbsp;&nbsp;If you need other options <a style="color: #ffb612; text-decoration: underline" href="/share-your-story">click here</a>.
              </p>
              <p style="font-size: 26px; padding-left: 15px; padding-right: 15px; font-family: Helvetica; font-style: italic">
                Hi, I'm (NAME) and someone cared about me enough to share how having a personal relationship with Jesus would change my life. And it has! Now I want to be that person for you! Below me
                there are video answers to life's hard questions and a link to my wonderful church!
              </p>
            </div>
          </div>
        </div>
        <a-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 0 }" :md="{ span: 16, offset: 0 }" :xl="{ span: 12, offset: 0 }" class="w-full">
          <!-- <a-card title="" class="style3"> -->
          <div class="record-description">
            <span style="font-size: 22px">Start recording by clicking on the camera and mic icon.</span>
          </div>
          <div class="video-wrapper" :style="{ display: isUploading ? 'none' : 'block' }">
            <video id="recordVideo" class="video-js" playsinline></video>
          </div>
          <div class="record-description">
            <span style="font-size: 22px">Stop button will appear in the lower left corner after you begin recording.</span>
          </div>
          <div class="record-description" style="display: flex; justify-content: center" v-if="isChallenge">
            <div style="max-width: 720px">
              <img src="resources/images/challenge-resource/film_like_this.png" alt="Truelife" style="width: 90%; margin-top: 30px; margin-bottom: 30px" />
            </div>
          </div>
          <a-row v-if="isUploading" align="middle">
            <a-col>
              <div class="upload-wrapper">
                <template v-if="progress < 99">
                  <a-row :gutter="[16, 16]">
                    <a-col>
                      <span>{{ progress }}%</span>
                    </a-col>
                  </a-row>
                  <a-row :gutter="[16, 16]">
                    <a-col>
                      <span>Processing...</span>
                    </a-col>
                  </a-row>
                </template>
                <template v-else>
                  <span class="text-center">
                    We are now converting your video into an MP4 format, this can take several minutes depending on the length of your Jesus Story.<br />
                    Please stay on this page until conversion is complete.
                  </span>
                </template>
              </div>
            </a-col>
          </a-row>
          <p v-if="isUploading" class="text-warn">Do not leave this page or you will need to start over.</p>
          <a-modal :title="permissionError.title" centered :footer="null" :visible="permissionError.visible" :closable="false">
            <div style="text-align: center">
              <p>
                {{ permissionError.message }}
              </p>
              <a-button
                type="primary"
                class="tf-btn tf-btn-primary"
                @click="
                  e => {
                    permissionError = {};
                  }
                "
              >
                OK
              </a-button>
            </div>
          </a-modal>
          <!-- </a-card> -->
        </a-col>
      </a-row>
    </div>
  </a-spin>
</template>

<script>
import 'video.js/dist/video-js.css';
import 'videojs-record/dist/css/videojs.record.css';
import videojs from 'video.js';
import RecordRTC from 'recordrtc';
import 'videojs-record/dist/videojs.record.js';
import 'webrtc-adapter';

const microphoneError = {
  title: 'Please allow TrueLife.org to use your camera.',
  message: 'TrueLife.org needs to access your camera so that you can record the video. Please activate your camera to be used for this website on your browser and/or computer settings.',
};
const cameraError = {
  title: 'Camera and microphone are blocked',
  message: 'Truelife.org requires access to your camera and microphone. Click the camera blocked icon in your browser’s address bar.',
};

const cardTitles = {
  shareYourStory: 'Record Share your story',
};

export default {
  data() {
    return {
      isLoading: false,
      player: '',
      redirectTo: null,
      isChallenge: false,
      options: {
        controls: true,
        autoplay: false,
        fluid: true,
        loop: false,
        width: 1280,
        height: 720,
        bigPlayButton: false,
        controlBar: {
          volumePanel: false,
          fullscreenToggle: true,
        },
        plugins: {
          record: {
            audio: true,
            video: {
              // video media constraints: set resolution of camera
              width: { min: 640, ideal: 1280, max: 1280 },
              height: { min: 480, ideal: 720, max: 720 },
            },
            debug: false,
            pip: false,
            maxLength: 600,
            frameWidth: 1280,
            frameHeight: 720,
          },
        },
      },
      isUploading: false,
      progress: 0,
      permissionError: {},
    };
  },
  mounted() {
    const { redirectTo } = this.$router.currentRoute.query;
    if (!redirectTo) {
      this.$router.push({ path: '/' });
    }
    this.redirectTo = redirectTo;

    this.player = videojs('#recordVideo', this.options, () => {
      let msg = 'Using video.js ' + videojs.VERSION + ' with videojs-record ' + videojs.getPluginVersion('record') + ' and recordrtc ' + RecordRTC.version;
      videojs.log(msg);
    });

    this.player.ready(() => {
      const button = document.querySelector('.vjs-device-button');
      button.onclick = async () => {
        if (await this.checkPermissions()) {
          this.isLoading = true;
          setTimeout(() => {
            this.isLoading = false;
            this.player.record().start();
          }, 5000);
        }
      };
    });

    this.player.on('finishRecord', () => {
      this.$router.replace({ name: this.redirectTo, params: { captured: this.player.recordedData, lang: this.$router.currentRoute.query.lang } });
    });

    this.player.on('error', (element, error) => {
      console.warn(error);
    });

    this.player.on('deviceError', () => {
      this.permissionError = cameraError;
      this.permissionError.visible = true;
    });
    if (redirectTo === 'shareYourStory') {
      this.isChallenge = true;
    }
  },
  methods: {
    cardTitle() {
      return cardTitles[this.redirectTo];
    },
    async checkPermissions() {
      const permissions = navigator.permissions;

      try {
        const { state } = await permissions.query({ name: 'microphone' });
        if (state !== 'granted') {
          this.permissionError = microphoneError;
          this.permissionError.visible = true;
          return;
        }
      } catch (e) {
        this.permissionError = microphoneError;
        this.permissionError.visible = true;
        return;
      }

      try {
        const { state } = await permissions.query({ name: 'camera' });
        if (state !== 'granted') {
          this.permissionError = cameraError;
          this.permissionError.visible = true;
          return;
        }
      } catch (e) {
        this.permissionError = cameraError;
        this.permissionError.visible = true;
        return;
      }

      return true;
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style lang="scss" scoped>
.w-full {
  width: 100%;
}
.video-wrapper {
  background-color: black;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  overflow: hidden;
  max-width: 720px;
  margin: 0 auto;
}
.upload-wrapper {
  display: flex;
  height: 400px;
  flex-direction: column;
  justify-content: center;
}
.text-warn {
  color: #ff0000;
}
.dark-theme {
  .challenge-logo {
    color: white;
  }
  .record-description {
    color: white;
  }
}
</style>
